import { PackageAbfragerRunComponents } from './components/AbfragerComponents';
import { PackageAbfragerRunClasses } from './classes/AbfragerClasses';
import '../Lazy/BootstrapButtons.css';
import '../Lazy/BootstrapTexts.css';
export class PackageAbfrager {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    components = new PackageAbfragerRunComponents();
    classes = new PackageAbfragerRunClasses();
}
